import React from "react";
import {useDispatch} from "react-redux";
import shortid from "shortid";
import {createSetContactDataAction} from "../../actions/dataActions";
import {Box, Button, Checkbox, Input, Table, Title} from "@allxsmith/bestax-bulma";


export default function InsuranceInfo({insuranceList}){
    const dispatch = useDispatch();

    const handleChange = (e, index) => {
        let insurance = {...insuranceList[index]};
        insurance[e.target.name] = e.target.value;
        updateInsurance(insurance, index);
    };

    const handleCheck = (e, index) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: e.target.checked
            }
        }
        handleChange(e, index)
    }

    const addInsurance = e => {
        let newInsurances = [...insuranceList];
        newInsurances.push({
            policy_name: "",
            policy_number: "",
            insurer: "",
            insurance_email: "",
            insurance_expiry_date: null,
            insurance_copy_save: false
        });
        dispatch(createSetContactDataAction({ "insurance_info": newInsurances }));
    };

    const updateInsurance = (insurance, index) => {
        let newInsurance = [...insuranceList];
        newInsurance.splice(index, 1, insurance);
        dispatch(createSetContactDataAction({ "insurance_info": newInsurance }));
    };

    const removeInsurance = index => {
        let newInsurance = [...insuranceList];
        newInsurance.splice(index, 1);
        dispatch(createSetContactDataAction({ "insurance_info": newInsurance }));
    };


    return (
        <Box>
            <details>
                <summary><Title>Insurance Info</Title></summary>
            <Table>
                <thead>
                    <tr>
                        <th>Policy Name</th>
                        <th>Policy Number</th>
                        <th>Insurer</th>
                        <th>Excess</th>
                        <th>Insurance Email</th>
                        <th>Insurance Expiry Date</th>
                        <th>Insurance Copy Saved</th>
                    </tr>
                </thead>
                <tbody>
                    {insuranceList && insuranceList.map((insurance,index) => (
                        <tr>
                            <td>
                                <Input
                                    name={"policy_name"}
                                    type={"text"}
                                    value={insurance.policy_name}
                                    onChange={e => handleChange(e, index)}
                                />
                            </td>
                            <td>
                                <Input
                                    name={"policy_number"}
                                    type={"text"}
                                    value={insurance.policy_number}
                                    onChange={e => handleChange(e, index)}
                                />
                            </td>
                            <td>
                                <Input
                                    name={"insurer"}
                                    type={"text"}
                                    value={insurance.insurer}
                                    onChange={e => handleChange(e, index)}
                                />
                            </td>
                            <td>
                                <Input
                                    name={"insurance_excess"}
                                    type={"number"}
                                    value={insurance.insurance_excess}
                                    onChange={e => handleChange(e, index)}
                                />
                            </td>
                            <td>
                                <Input
                                    name={"insurance_email"}
                                    type={"email"}
                                    value={insurance.insurance_email}
                                    onChange={e => handleChange(e, index)}
                                />
                            </td>
                            <td>
                                <Input
                                    name={"insurance_expiry_date"}
                                    type={"date"}
                                    value={insurance.insurance_expiry_date}
                                    onChange={e => handleChange(e, index)}
                                />
                            </td>
                            <td>
                                <Checkbox
                                    name={"insurance_copy_saved"}
                                    checked={insurance.insurance_copy_saved}
                                    onChange={e => handleCheck(e, index)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Button color={"primary"} onClick={addInsurance} data-testid={"add-insurance"}>
                Add Insurance Info
            </Button>
            </details>
        </Box>
    );


}